export default "__VITE_PUBLIC_ASSET__8b532f97__"